<template>
  <el-dialog
    :title="$t('shopCommunityWithdraw.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <el-form>
      <el-form-item :label="$t('shopCommunityWithdraw.withdrawReason')">
        <el-input
          v-model="shopCommunityWithdrawInfo.remark"
          type="textarea"
          :rows="3"
          :placeholder="$t('shopCommunityWithdraw.remarkPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeShopCommunityWithdrawModel">{{ $t('shopCommunityWithdraw.cancel') }}</el-button>
      <el-button type="primary" @click="updateShopCommunityWithdraw">{{ $t('shopCommunityWithdraw.confirmWithdraw') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { auditShopCommunity } from '@/api/admin/shopCommunityApi'

export default {
  name: 'ShopCommunityWithdraw',
  data() {
    return {
      dialogVisible: false,
      shopCommunityWithdrawInfo: {
        remark: '',
        state: ''
      }
    }
  },
  methods: {
    open(shopCommunity) {
      this.shopCommunityWithdrawInfo = { ...shopCommunity }
      this.dialogVisible = true
    },
    async updateShopCommunityWithdraw() {
      if (!this.shopCommunityWithdrawInfo.remark) {
        this.$message.error(this.$t('shopCommunityWithdraw.remarkRequired'))
        return
      }

      this.shopCommunityWithdrawInfo.state = '12001'
      try {
        await auditShopCommunity(this.shopCommunityWithdrawInfo)
        this.$message.success(this.$t('shopCommunityWithdraw.processSuccess'))
        this.dialogVisible = false
        this.$emit('auditShopCommunity', 'listAuditShopCommunitys', {})
      } catch (error) {
        this.$message.error(this.$t('shopCommunityWithdraw.processFailed') + error)
      }
    },
    closeShopCommunityWithdrawModel() {
      this.dialogVisible = false
    }
  }
}
</script>